import { isNil } from 'lodash';

export function pluralize(count: number, word: string, suffix = 's') {
  return `${word}${count !== 1 ? suffix : ''}`;
}

export function isNullOrWhitespace(value?: string | null): value is null | undefined | '' {
  if (isNil(value)) return true;

  return value.trim().length === 0;
}
